(function(){
  function fmt(n){ var s=String(Math.round(n)); var out=''; var c=0; for(var i=s.length-1;i>=0;i--){ out=s.charAt(i)+out; if(++c%3===0 && i>0) out='.'+out; } return '$'+out+',00'; }
  function initPrice(){
    var mapEl=document.getElementById('pe-variant-prices'); if(!mapEl) return;
    var prices={}; try{ prices=JSON.parse(mapEl.textContent); }catch(e){ return; }
    function currentId(){
      var hid=document.querySelector('form[action*="/cart/add"] input[name="id"], product-form input[name="id"]');
      if(hid && hid.value) return hid.value;
      var sel=document.querySelector('select[name="id"]'); if(sel && sel.value) return sel.value;
      return null;
    }
    function update(){
      var id=currentId(); if(!id) return; var cents=prices[id]; if(cents==null) return;
      var c=document.querySelector('.pe-cash__num'); if(!c) return;
      var list=Math.round(cents/100);
      var n=document.querySelector('.pe-precio__num'); if(n) n.textContent=fmt(list);
      c.textContent=fmt(Math.round(list*0.8));
      var li=document.querySelector('.pe-beneficios li'); if(li) li.innerHTML='<strong>6 cuotas sin interés</strong> de '+fmt(Math.round(list/6))+' c/u';
    }
    document.addEventListener('change', function(e){
      var t=e.target; if(!t) return;
      if(t.name==='id' || (t.closest && t.closest('variant-selects, variant-radios, .product-form__input, fieldset'))){
        update(); setTimeout(update,60); setTimeout(update,250);
      }
    });
  }
  function init(){
    var mediaWrap=document.querySelector('.product__media-wrapper');
    if(mediaWrap){
      var infoC=document.querySelector('.product__info-container')||document.querySelector('.product__info-wrapper');
      var desc=(infoC||document).querySelector('.product__description');
      if(desc && !mediaWrap.contains(desc)){
        var h=document.createElement('h2'); h.className='pe-desc-h'; h.textContent='Descripción';
        mediaWrap.appendChild(h); mediaWrap.appendChild(desc);
      }
      var qty=(infoC||document).querySelector('.product-form__quantity');
      var btns=document.querySelector('.product-form__buttons');
      if(qty && btns && !btns.classList.contains('pe-buygrid')){
        btns.insertBefore(qty, btns.firstChild);
        btns.classList.add('pe-buygrid');
      }
      var gallery=document.querySelector('.product__media-list')||mediaWrap;
      if(gallery && !document.querySelector('.pe-media-actions')){
        gallery.style.position='relative';
        var w=document.createElement('div'); w.className='pe-media-actions';
        var fav=document.createElement('button'); fav.type='button'; fav.setAttribute('aria-label','Favorito');
        fav.innerHTML="<svg viewBox='0 0 24 24' width='18' height='18' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><path d='M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9 6.8 19.2l1-5.8L3.5 9.2l5.9-.9z'/></svg>";
        fav.addEventListener('click',function(){fav.classList.toggle('is-on');});
        var sh=document.createElement('button'); sh.type='button'; sh.setAttribute('aria-label','Compartir');
        sh.innerHTML="<svg viewBox='0 0 24 24' width='18' height='18' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'><circle cx='18' cy='5' r='2.5'/><circle cx='6' cy='12' r='2.5'/><circle cx='18' cy='19' r='2.5'/><path d='M8.2 10.8l7.6-4.3M8.2 13.2l7.6 4.3'/></svg>";
        sh.addEventListener('click',function(){ if(navigator.share){navigator.share({title:document.title,url:location.href}).catch(function(){});}else if(navigator.clipboard){navigator.clipboard.writeText(location.href);} });
        w.appendChild(fav); w.appendChild(sh); gallery.appendChild(w);
      }
    }
    initPrice();
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
